import { brandAssetUrl, brandConfig } from './brandConfig';

export type TenantBrandingDto = {
  id?: string;
  tenantId?: string;
  productName?: string | null;
  loginTitle?: string | null;
  primaryColor?: string | null;
  secondaryColor?: string | null;
  logoUrl?: string | null;
  logoPreviewUrl?: string | null;
};

export type ResolvedCmsBranding = {
  productName: string;
  loginWelcome: string;
  appBarTitle: string;
  logoAlt: string;
  logoSrc: string;
  primaryColor: string;
  secondaryColor: string;
};

/** Merge tenant white-label branding with Hermész CMS defaults. */
export function resolveCmsBranding(
  branding?: TenantBrandingDto | null
): ResolvedCmsBranding {
  const productName = branding?.productName?.trim() || brandConfig.productName;
  const primaryColor =
    branding?.primaryColor?.trim() || brandConfig.colors.primary;
  const secondaryColor =
    branding?.secondaryColor?.trim() || brandConfig.colors.secondary;
  const loginWelcome =
    branding?.loginTitle?.trim() || brandConfig.loginWelcome;
  const logoSrc =
    branding?.logoPreviewUrl ||
    branding?.logoUrl ||
    brandAssetUrl(brandConfig.assets.logoSvg);

  return {
    productName,
    loginWelcome,
    appBarTitle: `${productName} Content management system`,
    logoAlt: `${productName} logo`,
    logoSrc,
    primaryColor,
    secondaryColor,
  };
}
